'use client'

import { SiNodedotjs, SiPython, SiTypescript } from '@icons-pack/react-simple-icons'
import { GitBranch, Star } from 'lucide-react'
import { cn } from '~/lib/utils'
import { FeatureCard } from './feature-card'

interface TestAssignmentsCardProps {
  className?: string
}

const repositoryCards = [
  {
    icon: <SiPython className="size-4" />,
    title: 'web-scraper',
    description: 'Веб-скрапер для сбора данных с сайтов',
    tech: 'Python, BeautifulSoup, Requests',
    stars: 12,
    forks: 3,
    className:
      '[grid-area:stack] hover:-translate-y-10 before:absolute before:w-[100%] before:outline-1 before:rounded-xl before:outline-border before:h-[100%] before:content-[\'\'] before:bg-blend-overlay before:bg-secondary/50 grayscale-[100%] hover:before:opacity-0 before:transition-opacity before:duration-700 hover:grayscale-0 before:left-0 before:top-0',
  },
  {
    icon: <SiTypescript className="size-4" />,
    title: 'react-dashboard',
    description: 'Дашборд с графиками и таблицами данных',
    tech: 'TypeScript, React, Chart.js',
    stars: 28,
    forks: 7,
    className:
      '[grid-area:stack] translate-x-12 translate-y-10 hover:-translate-y-1 before:absolute before:w-[100%] before:outline-1 before:rounded-xl before:outline-border before:h-[100%] before:content-[\'\'] before:bg-blend-overlay before:bg-secondary/50 grayscale-[100%] hover:before:opacity-0 before:transition-opacity before:duration-700 hover:grayscale-0 before:left-0 before:top-0',
  },
  {
    icon: <SiNodedotjs className="size-4" />,
    title: 'api-gateway',
    description: 'Микросервисный API Gateway с аутентификацией',
    tech: 'Node.js, Express, JWT',
    stars: 45,
    forks: 12,
    className: '[grid-area:stack] translate-x-24 translate-y-20 hover:translate-y-10',
  },
]

export function TestAssignments(props: TestAssignmentsCardProps) {
  return (
    <div className={cn('relative', props.className)}>
      <div className="absolute inset-x-0 z-1 flex justify-center pr-14 duration-200 ease-in group-hover:opacity-0">
        <div className="grid place-items-center [grid-template-areas:'stack']">
          {repositoryCards.map(card => (
            <div
              className={cn(
                `
                  relative flex h-36 w-[22rem] -skew-y-[8deg] transform-gpu flex-col justify-between rounded-xl border
                  p-4 font-mono backdrop-blur-sm transition-all duration-700 select-none
                `,
                'hover:border-foreground/20 hover:bg-muted',
                '[&>*]:flex [&>*]:items-center [&>*]:gap-2',
                card.className,
              )}
              key={card.title}
            >
              <div>
                {card.icon}
                <p className="text-sm font-medium">{card.title}</p>
              </div>
              <p className="line-clamp-2 text-sm text-balance">{card.description}</p>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3 text-xs text-muted-foreground">
                  <div className="flex items-center gap-1">
                    <Star className="h-3 w-3" />
                    <span>{card.stars}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <GitBranch className="h-3 w-3" />
                    <span>{card.forks}</span>
                  </div>
                </div>
                <p className="text-xs text-muted-foreground">{card.tech}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <FeatureCard
        background={null}
        title="Тестовые задания"
        description="Мини-проекты с собеседований: от создания API до веб-приложений. Реальные задания с подробными решениями, примерами кода и объяснениями архитектуры."
      />
    </div>
  )
}
